import { Link } from "react-router-dom";
import { Scale } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

export default function Footer() {
  const { t, lang } = useI18n();
  return (
    <footer className="no-print border-t border-border bg-primary text-primary-foreground mt-24">
      <div className="max-w-7xl mx-auto px-6 py-14 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <span className="grid place-items-center w-9 h-9 bg-primary-foreground text-primary"><Scale size={18} /></span>
            <span className="font-serif text-xl font-semibold">NC Legal Forms</span>
          </div>
          <p className="text-sm text-primary-foreground/70 max-w-md leading-relaxed">
            {t("footer.tagline")}
          </p>
        </div>
        <div>
          <p className="overline text-accent mb-4">{t("footer.product")}</p>
          <ul className="space-y-2 text-sm text-primary-foreground/70">
            <li><Link to="/forms" className="hover:text-white transition-colors">{t("nav.forms")}</Link></li>
            <li><Link to={["es", "fr", "ar", "hmn"].includes(lang) ? `/${lang}/nc` : "/nc"} className="hover:text-white transition-colors">{t("footer.byCounty")}</Link></li>
            <li><Link to="/for-attorneys" className="hover:text-white transition-colors">{t("nav.forAttorneys")}</Link></li>
            <li><Link to="/pricing" className="hover:text-white transition-colors">{t("nav.pricing")}</Link></li>
            <li><Link to="/dashboard" className="hover:text-white transition-colors">{t("nav.dashboard")}</Link></li>
          </ul>
        </div>
        <div>
          <p className="overline text-accent mb-4">{t("footer.legalHead")}</p>
          <ul className="space-y-2 text-sm text-primary-foreground/70">
            <li><Link to="/legal/terms" className="hover:text-white transition-colors">{t("footer.terms")}</Link></li>
            <li><Link to="/legal/privacy" className="hover:text-white transition-colors">{t("footer.privacy")}</Link></li>
            <li><Link to="/legal/eula" className="hover:text-white transition-colors">{t("footer.eula")}</Link></li>
          </ul>
          <p className="text-xs text-primary-foreground/60 leading-relaxed mt-4">
            {t("footer.disclaimer")}
          </p>
        </div>
      </div>
      <div className="border-t border-primary-foreground/10">
        <div className="max-w-7xl mx-auto px-6 py-5 text-xs text-primary-foreground/50">
          © {new Date().getFullYear()} NC Legal Forms. {t("footer.rights")}
        </div>
      </div>
    </footer>
  );
}
